import { SortDescriptor } from '@progress/kendo-data-query'
import { LeadDtoFilterKey, LeadDtoKey } from 'api/Clients/Types/LeadDto'

export const normalizeLeadsSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === LeadDtoKey.email) {
        return { ...x, field: LeadDtoFilterKey.email }
      }
      if (x.field === LeadDtoKey.tickmillCompany) {
        return { ...x, field: LeadDtoFilterKey.tickmillCompany }
      }
      if (x.field === LeadDtoKey.phoneNumber) {
        return { ...x, field: LeadDtoFilterKey.phoneNumber }
      }
      if (x.field === LeadDtoKey.firstName) {
        return { ...x, field: LeadDtoFilterKey.firstName }
      }
      if (x.field === LeadDtoKey.lastName) {
        return { ...x, field: LeadDtoFilterKey.lastName }
      }
      if (x.field === LeadDtoKey.country) {
        return { ...x, field: LeadDtoFilterKey.country }
      }
      return x
    })
    .filter((x) => !!x)
